<template>
  <div id="app">
    <router-view/>
    <messages/>
  </div>
</template>

<script>
import Messages from "@/components/Messages";
export default {
  components: {Messages}
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
